module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-39.9e0c8355.jpg";